import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// AUDIT LOG APIS
// ================================

// 1) Get Logs
export async function getAuditLogs(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no ?? 0);
    fd.append("search", payload.search || "");
    fd.append("type", payload.type || "");
    fd.append("from", payload.from || "");
    fd.append("to", payload.to || "");

    const res = await axios.post(`${apiBaseUrl}auditapis/get_logs`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Create Log (Reusable)
export async function createAuditLog(payload) {
  try {
    const fd = new FormData();

    fd.append("ulog_user", payload.ulog_user || "");
    fd.append("ulog_user_name", payload.ulog_user_name || "");
    fd.append("ulog_role", payload.ulog_role || "");
    fd.append("ulog_action", payload.ulog_action || "");
    fd.append("ulog_target", payload.ulog_target || "");
    fd.append("ulog_ip", payload.ulog_ip || "");
    fd.append("ulog_status", payload.ulog_status || "");
    fd.append("ulog_type", payload.ulog_type || "");

    const res = await axios.post(`${apiBaseUrl}auditapis/create_log`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Log Failed" };
  }
}
